import React from 'react';
import PropTypes from 'prop-types';
import DayPicker from 'react-day-picker';
import { formatDate, parseDate } from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import './MultipleDatePickerWrapper.css';

class MultipleDatePickerWrapper extends React.Component {
    
    render() {
        return (
            <div>
                <DayPicker
                    format={this.props.format}
                    formatDate={formatDate}
                    parseDate={parseDate}
                    selectedDays={this.props.selectedDays}
                    onDayClick={this.props.handleDayClick}
                    disabledDays={this.props.disablePrevious &&
                        {
                            before: new Date()
                        }
                    }
                />
            </div>
        );
    }
}

MultipleDatePickerWrapper.propTypes = {
    format: PropTypes.string,
    selectedDays: PropTypes.array,
    disablePrevious: PropTypes.bool,
    handleDayClick: PropTypes.func
}
  
export default MultipleDatePickerWrapper;


// WEBPACK FOOTER //
// ./src/components/Common/MultipleDatePickerWrapper/MultipleDatePickerWrapper.js